import { useCallback, useMemo } from "react";

import { PlusIcon } from "@phosphor-icons/react";
import { useNavigate } from "@tanstack/react-router";

import SourcesEmptyStateDark from "@gx/dls/assets/components/sources/SourcesEmptyStateDark";
import SourcesEmptyStateLight from "@gx/dls/assets/components/sources/SourcesEmptyStateLight";
import Button from "@gx/dls/buttons/Button";
import { GalaxyTheme, useGalaxyTheme } from "@gx/dls/theme";

import EmptyLayout from "@/layouts/EmptyLayout";

const SourcesPageEmptyLayout = () => {
  const { galaxyTheme } = useGalaxyTheme();
  const navigate = useNavigate();

  const handleNewSourceClick = useCallback(() => {
    void navigate({
      to: ".",
      search: (prev) => ({ ...prev, createSource: true }),
    });
  }, [navigate]);

  const svg = useMemo(() => {
    if (galaxyTheme === GalaxyTheme.DARK) {
      return <SourcesEmptyStateDark />;
    }
    return <SourcesEmptyStateLight />;
  }, [galaxyTheme]);

  return (
    <EmptyLayout
      title="No sources found"
      description="Add a source to get started"
      svg={svg}
      actions={<Button label="New source" icon={PlusIcon} onClick={handleNewSourceClick} />}
    />
  );
};

export default SourcesPageEmptyLayout;
